import {
  inject, observer,
} from 'mobx-react';
import * as React from 'react';
import {
  BrowserRouter, Route, Switch,
} from 'react-router-dom';
import AuthenticationRoute from './components/AuthenticationRoute/AuthenticationRoute';
import Layout from './components/Layout';
import {
  setI18nConfig,
} from './helperFunctions/translation';
import {
  AuthStore,
} from './mobx-store/stores/authStore';
import ForgotPassword from './screens/forgotPasswordScreen/forgotPassword';
import ResetPassword from './screens/forgotPasswordScreen/reserPasswordScreen/reserPassword';
import Login from './screens/loginScreen/login';
import UserDeleteRequestScreen from './screens/UserDeleteRequestScreen';
import RenewIwthPointsScreen from 'screens/RenewIwthPointsScreen';

interface IProps {
  authStore?: AuthStore;
}
@inject('authStore')
@observer
class App extends React.Component<IProps> {
  constructor(props: IProps) {
    super(props);
  }

  componentWillMount() {
    setI18nConfig();
  }

  render() {
    return (
      <BrowserRouter>
        <Switch>
          <Route exact path="/login" component={Login} />
          <Route path="/forgotPassword/verifyToken" component={ResetPassword} />
          <Route path="/forgotPassword" component={ForgotPassword} />
          <Route path="/userDeleteRequest" component={UserDeleteRequestScreen} />
          <Route path="/renewWithPoints" component={RenewIwthPointsScreen} />


          <AuthenticationRoute
            path="/"
            component={Layout}
            authFallbackRoute="login"
            hasPermission={this.props.authStore!.isAuthenticated}
            exact={false}
          />
        </Switch>
      </BrowserRouter>
    );
  }
}
export default App;
